"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { DropPartSize } from "@/components/drops/view/part/DropPart";
import { ProfileMinWithoutSubs } from "@/helpers/ProfileTypes";
export default function DropAuthorHandle(t0) {
  const $ = _c(11);
  const {
    profile: t1,
    size
  } = t0;
  const {
    handle
  } = t1;
  const searchParams = useSearchParams();
  const handleOrWallet = (searchParams?.get("user") ?? "").toLowerCase();
  const amIAuthor = handle?.toLowerCase() === handleOrWallet;
  let t2;
  if ($[0] !== size) {
    t2 = () => {
      switch (size) {
        case DropPartSize.SMALL:
          {
            return "tw-text-sm";
          }
        case DropPartSize.MEDIUM:
        case DropPartSize.LARGE:
          {
            return "tw-text-md";
          }
        default:
          {
            assertUnreachable(size);
            return "";
          }
      }
    };
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getTextClasses = t2;
  const textClasses = getTextClasses();
  if (amIAuthor) {
    const t3 = `${textClasses} tw-font-semibold tw-mb-0 tw-leading-none tw-text-iron-50`;
    let t4;
    if ($[2] !== handle || $[3] !== t3) {
      t4 = <p className={t3}>{handle}</p>;
      $[2] = handle;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  const t3 = `${textClasses} tw-mb-0 tw-leading-none tw-font-semibold tw-text-iron-50`;
  const t4 = `/${handle}`;
  let t5;
  if ($[5] !== handle || $[6] !== t4) {
    t5 = <Link onClick={_temp} href={t4} className="tw-no-underline hover:tw-underline hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{handle}</Link>;
    $[5] = handle;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <p className={t3}>{t5}</p>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(e) {
  return e.stopPropagation();
}